import * as React from 'react';

interface Props {
  image?: File;
  typeDocument: boolean;
  action?: string;
  documentFile: string;
  handleSubmitDocument?: (typeDocument: boolean) => void;

  download(): void;
}

const DocumentContractMiniatureComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div>

    <div>
      <p className="text-center pointer">
          <img
            style={{height: '169px'}}
            src={
              props.image ?
                // tslint:disable-next-line:no-any
                (window.URL || (window as any).webkitURL).createObjectURL(props.image) :
                '/img/copy-doc.png'
            }
            alt={'Contract Document'}
            onClick={props.download}
          />
      </p>
      {
        props.action ? 
        <button
          className="btn btn-secondary text-center center-block"
          onClick={() => props.handleSubmitDocument!(props.typeDocument)}
          style={{
            height: '40px',
            width: '350px'
          }}
        >
          {props.action}
        </button> :
        null
      }
    </div>
  </div>
);

export default DocumentContractMiniatureComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/sign-contracts/partials/DocumentContractMiniature.component.tsx